var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { HighlightedMarkets } from "./highlightedmarkets";
import { getMatchStatus, ServerDate, timeFormat, useForceUpdate } from "../../../lib/misc.functions";
import { LiveScoreStatusType } from "../../../definitions/constants/event-status-type.constant";
import { eventEndedStatuses } from "../../../definitions/constants/event-result-type";
import { eventMapping, eventUpdateSubject, marketMapping } from "../../../store/sportsbook.store";
import { betSlipActionSubject } from "../../../store/betslip.store";
import { isAndroid, isIOS, isMacOs, isWindows, osVersion } from 'react-device-detect';
import { rapidMarkets } from "../../../definitions/constants/market-categories.constant";
import { getFromLanguageFile, isMobileView } from "../../../app";
import { useTranslation } from "react-i18next";
import { TeamLogo } from "../../../shared/team-logo/team-logo";
var removerTimer = {};
var updateTimer = {};
export function Event(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    // const highlightedMarkets = props.highlightedMarkets;
    var eventType = props.eventType;
    var event = props.event;
    var parentEvent = props.parentEvent;
    var setShowEventDetail = props.context;
    var showEventDetail = props.showEventDetail;
    var fromOutSource = props.fromOutSource;
    var isDuelloCombination = props.isDuelloCombination;
    var i18n = useTranslation().i18n;
    var base = '/' + i18n.resolvedLanguage;
    var openAsNewPage = true;
    if ((isAndroid && Number(osVersion.split('.')[0]) >= 9) || isMacOs || isWindows ||
        (isIOS && Number(osVersion.split('.')[0]) >= 15)) {
        openAsNewPage = true;
    }
    var width = window.innerWidth;
    if (event.liveScoreStatus && event.mPT !== undefined && event.mPT !== null && event.mPT !== '' && event.mPT !== ' ' && Number(event.mPT) >= 0) {
        var time_statuses = ["520", "521", "522", "523", "700"];
        if (time_statuses.includes(event.liveScoreStatus.toString())) {
            event.minute = event.mPT + "'";
        }
        else {
            event.minute = LiveScoreStatusType[Number(event.liveScoreStatus)];
        }
    }
    var durationInMinutes = event.sS === 'futbol' ? 85 : 35;
    var diffMin = ServerDate().getTime() - new Date(event.eD).getTime();
    var exStatus = event.isRemoved;
    if (event && ((Number(event.iLE) === 1 && eventEndedStatuses.indexOf(event.liveScoreStatus) !== -1 && diffMin > (durationInMinutes * 60000)) ||
        (Number(event.iLE) === 0 && new Date(event.eD) < ServerDate()))) {
        event.isRemoved = true;
        if (exStatus !== event.isRemoved) {
            forceUpdate();
        }
    }
    else {
        event.isRemoved = false;
    }
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && event) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (events.betSlip.sportEvent.eventId === event.eventId) {
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(event.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (events.includes('duello')) {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    forceUpdate();
                }
            }
            else {
                if (event.mPT == 'FT') {
                    forceUpdate();
                }
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    if (updateTimer[String(event.eventId)]) {
                        clearTimeout(updateTimer[String(event.eventId)]);
                    }
                    updateTimer[String(event.eventId)] = setTimeout(function () {
                        forceUpdate();
                    }, 300);
                }
            }
        });
        return function () {
            if (removerTimer[String(event.eventId)]) {
                clearTimeout(removerTimer[String(event.eventId)]);
            }
            if (updateTimer[String(event.eventId)]) {
                clearTimeout(updateTimer[String(event.eventId)]);
            }
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
        };
    }, []);
    if (isDuelloCombination && parentEvent.showSubs !== true) {
        return _jsx(React.Fragment, {}, void 0);
    }
    var bettingPhase = Number(event.bP);
    if (event.mPT == 'FT' || event.iV == false) {
        removerTimer[String(event.eventId)] = setTimeout(function () {
            var ev = document.getElementById('eventId_' + event.eventId);
            if (ev) {
                try {
                    var evHasHeader = ev.parentElement.firstChild.className.includes('head');
                    var evHasChild = ev.parentElement.nextElementSibling.firstChild.className.includes('head');
                    if (evHasHeader && !evHasChild) {
                        ev.remove();
                    }
                    else {
                        ev.parentElement.remove();
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        }, 100);
    }
    var toggleEventCombinations = function (event) {
        event.showSubs = event.showSubs !== true ? true : false;
        var trigEvent = [event.eventId,];
        try {
            var event1 = eventMapping[String(event.eventClosedCombination[0].eventId)];
            if (event1) {
                trigEvent.push(String(event1.eventId));
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            var event2 = eventMapping[String(event.eventClosedCombination[1].eventId)];
            if (event2) {
                trigEvent.push(String(event2.eventId));
            }
        }
        catch (e) {
            console.error(e);
        }
        // forceUpdate();
        trigEvent.push('duello');
        eventUpdateSubject.next(trigEvent);
    };
    var offset = new Date().getTimezoneOffset() / 60;
    var getMatchPlayTime = function () {
        var date = new Date();
        var updateDate = new Date("".concat(date.getFullYear(), "-").concat((date.getMonth() + 1).toString().padStart(2, '0'), "-").concat(date.getDate().toString().padStart(2, '0'), "T").concat(event.scores.uA));
        updateDate = new Date(updateDate.setHours(updateDate.getHours() - offset));
        var msDiff = date.getTime() - updateDate.getTime(); //Future date - current date
        var secondDiff = Math.floor(msDiff / 1000);
        var minuteDiff = Math.floor(secondDiff / 60);
        if (minuteDiff > 0 && event.mPT != '') {
            try {
                var mPT = Number(event.mPT.replace("`", ""));
                if (mPT < 45) {
                    mPT = mPT + minuteDiff;
                    if (mPT > 45) {
                        return "45`";
                    }
                    else {
                        return mPT + "`";
                    }
                }
                else if (mPT < 90) {
                    mPT = mPT + minuteDiff;
                    if (mPT < 90) {
                        return mPT + "`";
                    }
                }
            }
            catch (e) {
            }
        }
        return event.mPT;
    };
    var haveRapidMarket = marketMapping[String(event.eventId)].filter(function (el) { return rapidMarkets.includes(el.mST) && (el.mS === 1 || el.mS < 0); });
    if (isMobileView) {
        return _jsx(MobileEvent, { event: event, parentEvent: parentEvent, isDuelloCombination: isDuelloCombination, eventType: eventType }, void 0);
    }
    else {
        return (_jsxs(React.Fragment, { children: [_jsxs("li", __assign({ onClick: function (e) {
                        if (e.target.id != "favorite-button") {
                            if (fromOutSource || openAsNewPage) {
                                navigate(base + '/sports/' + event.sS + '/' + eventType + '/' + event.cId + '/' + event.eventId);
                            }
                            else {
                                setShowEventDetail(event);
                            }
                            var sportsBookContainer = document.getElementById('sportsbook-container-id');
                            if (sportsBookContainer)
                                sportsBookContainer.classList.remove("multi-column-view-expanded");
                            var multiColumnToIcon = document.getElementById('multi-column-to-icon-id');
                            if (multiColumnToIcon) {
                                multiColumnToIcon.classList.add("bc-i-block-to-right");
                                multiColumnToIcon.classList.remove("bc-i-block-to-left");
                            }
                        }
                    } }, { children: [_jsx("div", __assign({ className: "multi-column-time-icon" }, { children: _jsxs("div", __assign({ className: "multi-column-icons" }, { children: [_jsx("i", { id: "favorite-button", className: "bc-i-favorite mr-1 ".concat(event.isFavorite ? 'favorite-animation' : ''), onClick: function () {
                                            event.isFavorite = !event.isFavorite;
                                            forceUpdate();
                                        } }, void 0), event.cur ? event.mPT != null
                                        ? _jsx("div", __assign({ className: "multi-column-single-team" }, { children: _jsx("div", __assign({ className: "minute-blink" }, { children: getMatchPlayTime() }), void 0) }), void 0)
                                        : _jsx(_Fragment, {}, void 0)
                                        : _jsx("time", __assign({ className: "" }, { children: _jsx("b", { children: timeFormat(event.eD) }, void 0) }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: "multi-column-event-container" }, { children: [_jsxs("div", __assign({ className: "multi-column-scores" }, { children: [event.scores && ((_b = (_a = event.scores) === null || _a === void 0 ? void 0 : _a.homeTeam) === null || _b === void 0 ? void 0 : _b.redCards) && ((_d = (_c = event.scores) === null || _c === void 0 ? void 0 : _c.homeTeam) === null || _d === void 0 ? void 0 : _d.redCards) > 0 &&
                                            _jsx("i", { title: "K\u0131rm\u0131z\u0131 Kartlar", className: "stats-section-icons-bc bc-i-card-football red" }, void 0), _jsxs("div", { children: [_jsx("b", __assign({ className: "market-game-odd" }, { children: ((_e = event === null || event === void 0 ? void 0 : event.cur) === null || _e === void 0 ? void 0 : _e.split(':')[0]) || "-" }), void 0), _jsx("b", { children: " : " }, void 0), _jsx("b", __assign({ className: "market-game-odd" }, { children: ((_f = event === null || event === void 0 ? void 0 : event.cur) === null || _f === void 0 ? void 0 : _f.split(':')[1]) || "-" }), void 0)] }, void 0), event.scores && ((_h = (_g = event.scores) === null || _g === void 0 ? void 0 : _g.awayTeam) === null || _h === void 0 ? void 0 : _h.redCards) && ((_k = (_j = event.scores) === null || _j === void 0 ? void 0 : _j.awayTeam) === null || _k === void 0 ? void 0 : _k.redCards) > 0 &&
                                            _jsx("i", { title: "K\u0131rm\u0131z\u0131 Kartlar", className: "stats-section-icons-bc bc-i-card-football red" }, void 0)] }), void 0), _jsxs("div", __assign({ className: "multi-column-teams participants" }, { children: [_jsxs("div", __assign({ className: "multi-column-single-team" }, { children: [_jsx(TeamLogo, { participantId: event.eP[0].participantId, className: "ftr-g-i-b-opp-logo-bc mr-1" }, void 0), event && event.eP && event.eP.length > 0 && (_jsx("p", __assign({ className: "ellipsis" }, { children: getFromLanguageFile(event.eP[0].participantName) ? getFromLanguageFile(event.eP[0].participantName) : event.eP[0].participantName }), void 0))] }), void 0), _jsx("b", { children: ":" }, void 0), _jsxs("div", __assign({ className: "multi-column-single-team" }, { children: [event && event.eP && event.eP.length > 0 &&
                                                    _jsx("p", __assign({ className: "ellipsis" }, { children: getFromLanguageFile(event.eP[1].participantName) ? getFromLanguageFile(event.eP[1].participantName) : event.eP[1].participantName }), void 0), _jsx(TeamLogo, { participantId: event.eP[1].participantId, className: "ftr-g-i-b-opp-logo-bc ml-1" }, void 0)] }), void 0)] }), void 0)] }), void 0)] }), void 0), _jsx("li", { children: _jsx("div", __assign({ className: "multi-column-teams" }, { children: (event.liveScoreStatus != null)
                            ? (_jsx("div", __assign({ className: "multi-column-single-team" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: getMatchStatus(event) }), void 0) }), void 0))
                            : (_jsx(_Fragment, {}, void 0)) }), void 0) }, void 0), event.eP.length > 1 &&
                    _jsx("li", __assign({ className: "multi-column-markets" }, { children: _jsx(HighlightedMarkets, { event: event, highlightedMarkets: event.highlightedMarkets }, void 0) }), void 0), _jsxs("li", __assign({ onClick: function () {
                        if (fromOutSource || openAsNewPage) {
                            navigate(base + '/sports/' + event.sS + '/' + eventType + '/' + event.cId + '/' + event.eventId);
                        }
                        else {
                            setShowEventDetail(event);
                        }
                        forceUpdate();
                    } }, { children: ["+", event.mOC] }), void 0)] }, void 0));
    }
}
export function MobileEvent(props) {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    // const highlightedMarkets = props.highlightedMarkets;
    var eventType = props.eventType;
    var event = props.event;
    var parentEvent = props.parentEvent;
    var isDuelloCombination = props.isDuelloCombination;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var base = '/' + i18n.resolvedLanguage;
    var openAsNewPage = true;
    if ((isAndroid && Number(osVersion.split('.')[0]) >= 9) || isMacOs || isWindows ||
        (isIOS && Number(osVersion.split('.')[0]) >= 15)) {
        openAsNewPage = true;
    }
    var width = window.innerWidth;
    if (event.liveScoreStatus && event.mPT !== undefined && event.mPT !== null && event.mPT !== '' && event.mPT !== ' ' && Number(event.mPT) >= 0) {
        var time_statuses = ["520", "521", "522", "523", "700"];
        if (time_statuses.includes(event.liveScoreStatus.toString())) {
            event.minute = event.mPT + "'";
        }
        else {
            event.minute = LiveScoreStatusType[Number(event.liveScoreStatus)];
        }
    }
    var durationInMinutes = event.sS === 'futbol' ? 85 : 35;
    var diffMin = ServerDate().getTime() - new Date(event.eD).getTime();
    var exStatus = event.isRemoved;
    if (event && ((Number(event.iLE) === 1 && eventEndedStatuses.indexOf(event.liveScoreStatus) !== -1 && diffMin > (durationInMinutes * 60000)) ||
        (Number(event.iLE) === 0 && new Date(event.eD) < ServerDate()))) {
        event.isRemoved = true;
        if (exStatus !== event.isRemoved) {
            forceUpdate();
        }
    }
    else {
        event.isRemoved = false;
    }
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && event) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (events.betSlip.sportEvent.eventId === event.eventId) {
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(event.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (events.includes('duello')) {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    forceUpdate();
                }
            }
            else {
                if (events.includes(String(event.eventId)) || events.includes(Number(event.eventId))) {
                    if (updateTimer[String(event.eventId)]) {
                        clearTimeout(updateTimer[String(event.eventId)]);
                    }
                    updateTimer[String(event.eventId)] = setTimeout(function () {
                        forceUpdate();
                    }, 300);
                }
            }
        });
        return function () {
            if (removerTimer[String(event.eventId)]) {
                clearTimeout(removerTimer[String(event.eventId)]);
            }
            if (updateTimer[String(event.eventId)]) {
                clearTimeout(updateTimer[String(event.eventId)]);
            }
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
        };
    }, []);
    if (isDuelloCombination && parentEvent.showSubs !== true) {
        return _jsx(React.Fragment, {}, void 0);
    }
    var bettingPhase = Number(event.bP);
    if (event.mPT == 'FT' || event.iV == false) {
        removerTimer[String(event.eventId)] = setTimeout(function () {
            var ev = document.getElementById('eventId_' + event.eventId);
            if (ev) {
                try {
                    var evHasHeader = ev.parentElement.firstChild.className.includes('head');
                    var evHasChild = ev.parentElement.nextElementSibling.firstChild.className.includes('head');
                    if (evHasHeader && !evHasChild) {
                        ev.remove();
                    }
                    else {
                        ev.parentElement.remove();
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        }, 100);
    }
    var offset = new Date().getTimezoneOffset() / 60;
    var getMatchPlayTime = function () {
        var date = new Date();
        var updateDate = new Date("".concat(date.getFullYear(), "-").concat((date.getMonth() + 1).toString().padStart(2, '0'), "-").concat(date.getDate().toString().padStart(2, '0'), "T").concat(event.scores.uA));
        updateDate = new Date(updateDate.setHours(updateDate.getHours() - offset));
        var msDiff = date.getTime() - updateDate.getTime(); //Future date - current date
        var secondDiff = Math.floor(msDiff / 1000);
        var minuteDiff = Math.floor(secondDiff / 60);
        if (minuteDiff > 0 && event.mPT != '') {
            try {
                var mPT = Number(event.mPT.replace("`", ""));
                if (mPT < 45) {
                    mPT = mPT + minuteDiff;
                    if (mPT > 45) {
                        return "45`";
                    }
                    else {
                        return mPT + "`";
                    }
                }
                else if (mPT < 90) {
                    mPT = mPT + minuteDiff;
                    if (mPT < 90) {
                        return mPT + "`";
                    }
                }
            }
            catch (e) {
            }
        }
        return event.mPT;
    };
    var getShortDate = function (eventDate) {
        var date = new Date(eventDate);
        date = new Date(date.setHours(date.getHours() - offset));
        return "".concat(date.getDate().toString().padStart(2, '0'), "/").concat((date.getMonth() + 1).toString().padStart(2, '0'));
    };
    return (_jsxs("div", __assign({ className: "sw-container-bc", style: { transform: "translateX(0px)" } }, { children: [_jsxs("div", __assign({ className: "mobile-event-teams-row" }, { children: [_jsx("i", { id: "favorite-button", className: "bc-i-favorite mobile-fav-btn ".concat(event.isFavorite ? 'favorite-animation' : ''), onClick: function () {
                            event.isFavorite = !event.isFavorite;
                            forceUpdate();
                        } }, void 0), _jsxs("div", __assign({ className: "mobile-event-teams", onClick: function () { return navigate(base + '/sports/' + event.sS + '/1/' + event.cId + '/' + event.eventId); } }, { children: [_jsxs("div", __assign({ className: "mobile-team-row" }, { children: [_jsx(TeamLogo, { participantId: event.eP[0].participantId, className: "mobile-team-logo" }, void 0), _jsx("span", __assign({ className: "mobile-team-name ellipsis", title: event.eP[0].participantName }, { children: getFromLanguageFile(event.eP[0].nameId) ? getFromLanguageFile(event.eP[0].nameId) : event.eP[0].participantName }), void 0), event.cur && _jsx("b", __assign({ className: "mobile-team-score" }, { children: event.cur.split(':')[0] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "mobile-team-row" }, { children: [_jsx(TeamLogo, { participantId: event.eP[1].participantId, className: "mobile-team-logo" }, void 0), _jsx("span", __assign({ className: "mobile-team-name ellipsis", title: event.eP[1].participantName }, { children: getFromLanguageFile(event.eP[1].nameId) ? getFromLanguageFile(event.eP[1].nameId) : event.eP[1].participantName }), void 0), event.cur && _jsx("b", __assign({ className: "mobile-team-score" }, { children: event.cur.split(':')[1] }), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "mobile-event-actions" }, { children: [_jsx("i", { className: "bc-i-statistics mobile-action-icon", onClick: function () { return navigate(base + '/sports/' + event.sS + '/1/' + event.cId + '/' + event.eventId); } }, void 0), _jsx("span", __assign({ className: "mobile-more-btn", onClick: function () { return navigate(base + '/sports/' + event.sS + '/1/' + event.cId + '/' + event.eventId); } }, { children: "+" }), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "mobile-event-odds-row" }, { children: [_jsx("div", __assign({ className: "mobile-event-datetime" }, { children: event.cur
                            ? (event.mPT != null
                                ? _jsx("span", __assign({ className: "minute-blink" }, { children: getMatchPlayTime() }), void 0)
                                : null)
                            : _jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "mobile-event-date" }, { children: getShortDate(event.eD) }), void 0), _jsx("span", __assign({ className: "mobile-event-time" }, { children: timeFormat(event.eD) }), void 0)] }, void 0) }), void 0), event.eP.length > 1 && (_jsx("div", __assign({ className: "mobile-event-markets" }, { children: _jsx(HighlightedMarkets, { event: event, highlightedMarkets: event.highlightedMarkets }, void 0) }), void 0))] }), void 0)] }), void 0));
}
